import { render, staticRenderFns } from "./AppearanceEditColor.vue?vue&type=template&id=39a3c737&scoped=true&"
import script from "./AppearanceEditColor.vue?vue&type=script&lang=js&"
export * from "./AppearanceEditColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a3c737",
  null
  
)

export default component.exports